import { images } from "../../../functions";
import { TScenesReplay } from "./ScenesReplay";


export type ScenesReplayListKey = 'v25VanessaJoeLivingRoom' | 'v3vanCoffeeBJ'
    | 'v3AnnMcFirstHJ' | 'v4VanessaAlleyBlowjob' | 'v4VanessaRickToiletBJ' | 'v4AnnFirstBJ' | "v4Sextape" | "v5MerryMCToilet" | "v5AnnFirstSex" | "v6AnnJoeRivalBJ"
    | "v6AnnChrisMemory" | "v6VanessaLivingRoom" | "v7AnnPrePhotoshootSex" | "v7AnnPhotoshootAlleySex" | "v7AnnMoviesChris" | "v7VanessaMarioOutfit" | "v7VanessaFoot" | "v7VanessaMCHungry"
    | "v7AnnPreAuditionChris" | "v7AnnPreAuditionMC" | "v7AmberSex" | "v8EmilyNight" | "v8AnnDateBJFerris" | "v8AnnWebcam" | "v8EmilyAlone" | "v8EmilyEx" | "v8VanessaAnal" | "v8VanessaFingering"
    | "v8McVanessaAngelaBeach" | "v8McVanessaJoeThreesome" | "v8annBeforeLibrarySex" | "v8annLibraryGuy" | "v8annLibraryGirl" | "v8AnnChrisSexting" | "v8AnnChrisMCThreesome" | "v8annMCAlley"
    | "v8VanessaCustomerHotel" | "V9VanessaBus" | "V9VanessaBusMoveSeat" | "V9VanessaMCChrisBarVanessaWithChris" | "V9VanessaMCChrisBarJoinKimVanessa" | "V9VanessaMCChrisBarJoinKim" | "V9VanessaMCBusNight_2"
    | "V9AnnMCNightConv_Quicky" | "V9AnnDormNightChris_Sex" | "V9EmilyMorningDay2_Room_Touched" | "V9AnnMCMotel_Driving" | "V9AnnMCMotel_InviteGuys_MC_Sofa" | "V9AnnMCMotel_InviteGuys_MCNotSofa"
    | "V9AnnMCMotel_Alone_Passionate" | "V9AnnMCMotel_Alone_Rough"
    ;

export const replayScenesList: { [key in ScenesReplayListKey]: TScenesReplay; } = {
    ...createReplay({
        ID: "v25VanessaJoeLivingRoom",
        text: "Expected no less",
        tags: ["NTR", "VAGINAL"],
        imageKey: images.v2_5.TODJoeVanessaFuck2.key,
        scene: "TODWatchingVanessaJoe",
        page: 0,
        chars: ["vanessa"],
    }),
    ...createReplay({
        ID: "v3vanCoffeeBJ",
        text: "Romantic blackmail",
        tags: ["BLOWJOB"],
        imageKey: images.v3.Anim_VanessaCoffeeHJ.key,
        scene: "VanessaCoffee5Blackmail",
        page: 0,
        chars: ["vanessa"],
    }),
    ...createReplay({
        ID: "v3AnnMcFirstHJ",
        text: "Just a kiss",
        tags: ["HANDJOB"],
        imageKey: images.v3.AnnRoom16.key,
        scene: "AnnAfterTODLove2",
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "v4VanessaAlleyBlowjob",
        text: "Enjoy the show",
        tags: ["NTR", "BLOWJOB"],
        imageKey: images.v4.BarVanessaAlley20.key,
        scene: "ClubEventWithoutJoeInsideGoToVanessa2",
        page: 0,
        chars: ["vanessa"],
    }),
    ...createReplay({
        ID: "v4VanessaRickToiletBJ",
        text: "A real nympho",
        tags: ["NTR", "BLOWJOB"],
        imageKey: images.v4.Anim_BarVanessaToilet.key,
        scene: "ClubEventJoeInsideDontTurnAround2",
        page: 0,
        chars: ["vanessa"],
    }),
    ...createReplay({
        ID: "v4AnnFirstBJ",
        text: "What I really want",
        tags: ["BLOWJOB"],
        imageKey: images.v4.AfterBarAnnRoom12.key,
        scene: "AfterClub2To4Home",
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "v4Sextape",
        text: "Make a sex tape",
        imageKey: images.v4.SexTape13.key,
        scene: "AfterClubSexTape",
        tags: ["NTR", "BLOWJOB", "VAGINAL"],
        page: 0,
        chars: ["vanessa"],
    }),
    ...createReplay({
        ID: "v5MerryMCToilet",
        text: "Not in the pussy",
        imageKey: images.v5.ChrisMerry_22.key,
        scene: "V5ChrisRandomGirl_ReturnToMerry",
        tags: ["BLOWJOB", "ANAL"],
        page: 0,
        chars: ["merry"],
    }),
    ...createReplay({
        ID: "v5AnnFirstSex",
        text: "Please be gentle",
        imageKey: images.v5.AnnRoomEvening_27.key,
        scene: "V5AnnSexEvening2",
        tags: ["BLOWJOB", "VAGINAL"],
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "v6AnnJoeRivalBJ",
        text: "Make Joe forgive you",
        imageKey: images.v6.VanessaHouse_16.key,
        scene: "V6VanessaHomeRoomJoeRival",
        tags: ["BLOWJOB", "NTR"],
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "v6AnnChrisMemory",
        text: "Don't expect much",
        imageKey: images.v6.AnnChrisMemory_5.key,
        scene: "V6VanessaHomeRoom_2_AnnChrisStory_Question_Listen",
        tags: ["BLOWJOB", "NTR"],
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "v6VanessaLivingRoom",
        text: "Hard already",
        imageKey: images.v6.VanessasLivingRoom_21.key,
        scene: "V6VanessaLivingRoom",
        tags: ["BLOWJOB", "VAGINAL", "NTR"],
        page: 0,
        chars: ["vanessa"],
    }),
    ...createReplay({
        ID: "v7AnnPrePhotoshootSex",
        text: "Lean on the table",
        imageKey: images.v7.V7AnnMCRoom_18.key,
        scene: "V7AnnAtMCRoom2_Question_Touch",
        tags: ["BLOWJOB", "VAGINAL"],
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "v7AnnPhotoshootAlleySex",
        text: "Wow. That was fast",
        imageKey: images.v7.V7AnnOutside_53.key,
        scene: "V7AnnMCAlleyPhotoShoot5_Question_Fuck",
        tags: ["VAGINAL", "NTR"],
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "v7AnnMoviesChris",
        text: "What are friends for?",
        imageKey: images.v7.V7AnnChrisMovie_27.key,
        scene: "V7AnnChrisMCMovies3",
        tags: ["FOREPLAY", "NTR"],
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "v7VanessaFoot",
        text: "Mama is here",
        imageKey: images.v7.V7VanessaMCNudeHome_3.key,
        scene: "V7VanessaMorning2_Naked",
        tags: ["FOOTJOB"],
        page: 0,
        chars: ["vanessa"],
    }),
    ...createReplay({
        ID: "v7VanessaMCHungry",
        text: "Are you hungry?",
        imageKey: images.v7.V7VanessaMCNudeHome_14.key,
        scene: "V7VanessaMorning2_EatPussy",
        tags: ["FOOTJOB"],
        page: 0,
        chars: ["vanessa"],
    }),

    ...createReplay({
        ID: "v7AmberSex",
        text: "Help her out",
        imageKey: images.v7.AmberSex_7.key,
        scene: "V7ReturningOutfit_McAmber",
        tags: ["BLOWJOB", "VAGINAL"],
        page: 0,
        chars: ["amber"],
    }),
    ...createReplay({
        ID: "v7VanessaMarioOutfit",
        text: "Harder big boy!",
        imageKey: images.v7.AmberMario_6.key,
        scene: "V7ReturningOutfit_LivingRoomEarlyMarioVanessaFuck",
        tags: ["ANAL", "NTR"],
        page: 0,
        chars: ["vanessa"],
    }),
    ...createReplay({
        ID: "v7AnnPreAuditionMC",
        text: "You know what to do",
        imageKey: images.v7.Anim_AnnMCPreAudition.key,
        scene: "V7AnnPreAudition3_Beg_Question_Naked",
        tags: ["BLOWJOB"],
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "v7AnnPreAuditionChris",
        text: "Don't break character",
        imageKey: images.v7.AnnChrisPreAudition_22.key,
        scene: "V7AnnPreAuditionNtr_InviteChris2_Beg_Question_Agree",
        tags: ["BLOWJOB", "NTR"],
        page: 0,
        chars: ["ann"],
    }),

    ...createReplay({
        ID: "v8AnnDateBJFerris",
        text: "keep you distracted.",
        imageKey: images.v8.Anim_AnnFerrisWheelBJ.key,
        scene: "V8AnnDate_OnRideTop_PulledDickOut",
        tags: ["BLOWJOB"],
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "v8EmilyNight",
        text: "High-five!",
        imageKey: images.v8.Anim_V8EmilyMCGrope.key,
        scene: "V8EmilyAnnMovieNight_AloneWithEmily",
        tags: ["FOREPLAY"],
        page: 0,
        chars: ["emily"],
    }),
    ...createReplay({
        ID: "v8McVanessaAngelaBeach",
        text: "That is my cue...",
        imageKey: images.v8.Anim_MCAngelaDoggy.key,
        scene: "V8VanessaMCBeach_FuckAngela",
        tags: ["VAGINAL"],
        page: 0,
        chars: ["angela"],
    }),

    ...createReplay({
        ID: "v8McVanessaJoeThreesome",
        text: "Our special guest",
        imageKey: images.v8.V8MCJoeVanessa_65.key,
        scene: "V8VanessaJoeMCThreesome_2",
        tags: ["BLOWJOB", "VAGINAL", "THREESOME"],
        page: 0,
        chars: ["vanessa"],
    }),
    ...createReplay({
        ID: "v8AnnWebcam",
        text: "Can you see me?",
        imageKey: images.v8.Anim_AnnDormMasturbateUpDown.key,
        scene: "V8AnnWebcam",
        tags: ["FOREPLAY"],
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "v8EmilyAlone",
        text: "Oh shit!",
        imageKey: images.v8.Anim_EmilyMasturbation.key,
        scene: "V8EmilyAlone",
        tags: ["FOREPLAY"],
        page: 0,
        chars: ["emily"],
    }),
    ...createReplay({
        ID: "v8EmilyEx",
        text: "I missed you too!",
        imageKey: images.v8.Anim_EmilyExSex.key,
        scene: "V8EmilyAndEx_KeepWatching",
        tags: ["BLOWJOB", "VAGINAL", "NTR"],
        page: 0,
        chars: ["emily"],
    }),
    ...createReplay({
        ID: "v8VanessaAnal",
        text: "Let me just stretch",
        imageKey: images.v8.V8VanessaMCNight_29.key,
        scene: "V8VanessaMCNight_FuckHer",
        tags: ["ANAL"],
        page: 0,
        chars: ["vanessa"],
    }),
    ...createReplay({
        ID: "v8VanessaFingering",
        text: "You are dripping",
        imageKey: images.v8.V8VanessaMCNight_41.key,
        scene: "V8VanessaMCNight_DenyHer",
        tags: ["FOREPLAY"],
        page: 0,
        chars: ["vanessa"],
    }),
    ...createReplay({
        ID: "v8annBeforeLibrarySex",
        text: "You asked for it",
        imageKey: images.v8.V8AnnCorruptionBeforeLibrary_28.key,
        scene: "V8AnnCorruptionBeforeLibrary_Fuck",
        tags: ["VAGINAL", "BLOWJOB"],
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "v8annLibraryGuy",
        text: "Are you running from me?",
        imageKey: images.v8.V8AnnCorruptionLibrary_14.key,
        scene: "V8AnnCorruptionLibrary_PickedGuy",
        tags: ["BLOWJOB", "NTR"],
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "v8annLibraryGirl",
        text: "I'm so sorry!!!",
        imageKey: images.v8.V8AnnCorruptionLibrary_37.key,
        scene: "V8AnnCorruptionLibrary_PickedGirl",
        tags: ["PUSSYLICK"],
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "v8AnnChrisSexting",
        text: "Typing with one hand",
        imageKey: images.v8.V8AnnChrisPics_11.key,
        scene: "V8AnnChrisTexting",
        tags: ["BLOWJOB", "NTR", "VAGINAL", "PINUP", "PUSSYLICK"],
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "v8AnnChrisMCThreesome",
        text: "Let's see how the night goes...",
        imageKey: images.v8.Anim_V8AnnChrisMCDoggyChrisBJ.key,
        scene: "V8AnnChrisHouse_2",
        tags: ["BLOWJOB", "NTR", "VAGINAL", "PINUP", "PUSSYLICK", "THREESOME"],
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "v8annMCAlley",
        text: "I know a shortcut",
        imageKey: images.v8.V8AnnMCAlley_13.key,
        scene: "V8AnnCorruptionAlley_Tease",
        tags: ["NTR", "FOREPLAY"],
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "v8VanessaCustomerHotel",
        text: "Yes Master",
        imageKey: images.v8.V8VanessaCustomerHotel_43.key,
        scene: "V8VanessaCustomerHotel_2",
        tags: ["BLOWJOB"],
        page: 0,
        chars: ["vanessa"],
    }),
    ...createReplay({
        ID: "V9VanessaBus",
        text: "She tickled my curiosity...",
        imageKey: images.v9.V9VanessaMCOutsideBus_12.key,
        scene: "V9VanessaBus_MCLeadingBet",
        tags: ["HANDJOB", "FOREPLAY"],
        page: 0,
        chars: ["vanessa"],
    }),
    ...createReplay({
        ID: "V9VanessaBusMoveSeat",
        text: "A bet is a bet I guess...",
        imageKey: images.v9.Anim_V9VanessaMCOutsideBusStorking.key,
        scene: "V9VanessaBus_VanessaLeadingBet",
        tags: ["HANDJOB", "FOREPLAY", "NTR"],
        page: 0,
        chars: ["vanessa"],
    }),
    ...createReplay({
        ID: "V9VanessaMCChrisBarVanessaWithChris",
        text: "There you go bro.",
        imageKey: images.v9.Anim_V9VanessaChrisBehindBarLeaning.key,
        scene: "V9VanessaMCChrisBarVanessaWithChris",
        tags: ["VAGINAL", "BLOWJOB", "NTR"],
        page: 0,
        chars: ["vanessa"],
    }),
    ...createReplay({
        ID: "V9VanessaMCChrisBarJoinKim",
        text: "Where Does Chris find these girls?",
        imageKey: images.v9.V9BarToilet_14.key,
        scene: "V9VanessaMCChrisBarJoinKim",
        tags: ["VAGINAL", "BLOWJOB", "THREESOME"],
        page: 0,
        chars: ["vanessa", "kim"],
    }),
    ...createReplay({
        ID: "V9VanessaMCChrisBarJoinKimVanessa",
        text: "Ah shit, here we go again.",
        imageKey: images.v9.Anim_V9VanessaChrisBarToiletLickingTogether.key,
        scene: "V9VanessaMCChrisBarJoinKim",
        tags: ["VAGINAL", "BLOWJOB", "THREESOME"],
        page: 0,
        chars: ["vanessa", "kim"],
    }),
    ...createReplay({
        ID: "V9VanessaMCBusNight_2",
        text: "Are we done for today?",
        imageKey: images.v9.V9VanessaMCBusNight_9.key,
        scene: "V9VanessaMCBusNight_2",
        tags: ["FOREPLAY"],
        page: 0,
        chars: ["vanessa"],
    }),
    ...createReplay({
        ID: "V9AnnMCNightConv_Quicky",
        text: "It was quick!",
        imageKey: images.v9.Anim_V9AnnCorNightHJ.key,
        scene: "V9AnnMCNightConv_Quicky",
        tags: ["HANDJOB"],
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "V9AnnDormNightChris_Sex",
        text: "I'm sorry, but you have to go.",
        imageKey: images.v9.V9MCRoomAnnWebcam_12.key,
        scene: "V9AnnDormNightChris_Sex",
        tags: ["BLOWJOB", "VAGINAL", "NTR"],
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "V9EmilyMorningDay2_Room_Touched",
        text: "No! I didn't finish!",
        imageKey: images.v9.Anim_V9EmilyMCMorningTogether.key,
        scene: "V9EmilyMorningDay2_Room_Touched",
        tags: ["FOREPLAY"],
        page: 0,
        chars: ["emily"],
    }),
    ...createReplay({
        ID: "V9AnnMCMotel_Driving",
        text: "It's a pretty long drive...",
        imageKey: images.v9.V9AnnMCMotelDriving_4.key,
        scene: "V9AnnMCMotel_Driving",
        tags: ["BLOWJOB"],
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "V9AnnMCMotel_Alone_Passionate",
        text: "I'm the luckiest person alive.",
        imageKey: images.v9.V9AnnMCMotel_163.key,
        scene: "V9AnnMCMotel_Alone_Passionate",
        tags: ["BLOWJOB", "PUSSYLICK", "VAGINAL", "FOREPLAY",],
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "V9AnnMCMotel_Alone_Rough",
        text: "Are you awake?",
        imageKey: images.v9.V9AnnMCMotel_135.key,
        scene: "V9AnnMCMotel_Alone_Rough",
        tags: ["BLOWJOB", "PUSSYLICK", "VAGINAL", "FOREPLAY", "ANAL"],
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "V9AnnMCMotel_InviteGuys_MCNotSofa",
        text: "Are you awake?",
        imageKey: images.v9.V9AnnMCMotel_99.key,
        scene: "V9AnnMCMotel_InviteGuys_MCNotSofa",
        tags: ["BLOWJOB"],
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "V9AnnMCMotel_InviteGuys_MC_Sofa",
        text: "It seemed harmless at first...",
        imageKey: images.v9.V9AnnMCMotel_234.key,
        scene: "V9AnnMCMotel_InviteGuys_MC_Sofa",
        tags: ["BLOWJOB", "NTR", "THREESOME", "ANAL"],
        page: 0,
        chars: ["ann"],
    }),
    ...createReplay({
        ID: "V9AnnMCMotel_InviteGuys_MC_Sofa",
        text: "It seemed harmless at first...",
        imageKey: images.v9.V9AnnMCMotel_234.key,
        scene: "V9AnnMCMotel_InviteGuys_MC_Sofa",
        tags: ["BLOWJOB", "NTR", "THREESOME", "ANAL"],
        page: 0,
        chars: ["ann"],
    }),

};

function createReplay<ID extends ScenesReplayListKey>(data: Omit<TScenesReplay, "seen" | "gameState"> & { ID: ID; }): { [key in ID]: TScenesReplay } {
    const result = {
        [data.ID]: {
            ...data,
            text: data.text,
            imageKey: data.imageKey,
            ID: data.ID,
            scene: data.scene,
            page: data.page,
            gameState: null,
            chars: data.chars,
            seen: false
        } as TScenesReplay
    };
    return result as { [key in ID]: TScenesReplay };
}
